import SiteUtil from '@shared/utils/siteUtil.js'

export default defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserStore()

  if (to.meta.public || to.meta.auth === false) {
    return
  }

  if (!userStore.isAuthenticated) {
    console.log('Auth middleware: User not authenticated. Redirecting to login.')

    const candidate = to.fullPath !== '/' ? to.fullPath : undefined
    const redirectTo = SiteUtil.safeInternalRedirect(candidate)

    if (to.path !== '/login') {
      return navigateTo({
        path: '/login',
        query: {
          ...(redirectTo && { redirectTo }),
        },
      }, { replace: true })
    }
  }

  if (to.meta.roles && Array.isArray(to.meta.roles) && to.meta.roles.length > 0) {
    const userRole = userStore.profile?.role
    if (!userRole || !to.meta.roles.includes(userRole)) {
      console.log(`Auth middleware: User role '${userRole}' not authorized for route '${to.path}'.`)

      return navigateTo('/not-authorized', { replace: true })
    }
  }
})
